export default {
  'highlights-heading':
    'A space for sharing ideas and finding inspiration on the best gifts to buy',
}
